import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function ActionBarActions({ children }) {
    return jsx(Wrapper, { children: children });
}
const Wrapper = styled("div")(({ theme }) => ({
    "& > *:first-child": {
        marginLeft: theme.spacing(1),
    },
    "> *": {
        marginRight: theme.spacing(2),
    },
    "& > *:last-child": {
        marginRight: 0,
    },
}));

export { ActionBarActions, Wrapper };
//# sourceMappingURL=ActionBarActions.js.map
